export function renderAnnonceDetails(annonce) {
  const { categorie } = annonce;

  switch (categorie) {
    case "voiture":
      return (
        <>
          <h4>Type de véhicule : {annonce.typeVehicule}</h4>
          <h4>Année du modèle : {annonce.annee}</h4>
          <h4>Carburant : {annonce.carburant}</h4>
          <h4>Kilométrage : {annonce.kilometrage} km</h4>
          <h4>Nombre de chevaux : {annonce.chevaux}</h4>
        </>
      );

    case "logement":
      return (
        <>
          <h4>Type de bien : {annonce.typeBien}</h4>
          <h4>Type de transaction : {annonce.transaction}</h4>
          <h4>Condition de visite: {annonce.conditionVisite}</h4>
          <div className="doubleColonne">
            <div className="colonne">
              <h4>Surface : {annonce.surface}m²</h4>
              <h4>Nombre de pièces : {annonce.nombrePieces}</h4>
            </div>
            <div className="colonne">
              <h4>Extérieur : {annonce.exterieur}</h4>
              <h4>Ville : {annonce.ville}</h4>
            </div>
          </div>
        </>
      );

    case "terrain":
      return (
        <>
          <h4>Ville : {annonce.ville}</h4>
          <h4>Surface : {annonce.surface}</h4>
          <h4>Type de terrain : {annonce.typeTerrain}</h4>
        </>
      );

    case "formation":
      return <h4>Secteur d'activité : {annonce.secteur}</h4>;

    case "travail":
      return (
        <>
          <h4>Secteur d'activité : {annonce.secteur}</h4>
          <h4>Type de contrat : {annonce.contrat}</h4>
          <h4>Durée du contrat : {annonce.duree}</h4>
        </>
      );

    case "outillage":
    case "rencontre":
      return (
        <h4 className="descriptionBis">Description : {annonce.description}</h4>
      );

    case "alimentation":
      return (
        <>
          <h4>Type d'aliment : {annonce.typeAliment}</h4>
          <h4>Conservation : {annonce.conservation}</h4>
          <h4 className="descriptionBis">Description : {annonce.description}</h4>
        </>
      );

    case "plante":
      return (
        <>
          <h4>Type de plante : {annonce.typePlante}</h4>
          <h4>Variété : {annonce.variete}</h4>
          <h4 className="descriptionBis">Description : {annonce.description}</h4>
        </>
      );

    case "animaux":
      return (
        <>
          <h4>Espèce : {annonce.espece}</h4>
          <h4 className="descriptionBis">Description : {annonce.description}</h4>
        </>
      );

    case "Equipement":
    case "EquipementEvenement":
      return (
        <>
          <h4>Type : {annonce.typeEquipement}</h4>
          <h4>État: {annonce.etat}</h4>
          <h4 className="descriptionBis">Description : {annonce.description}</h4>
        </>
      );
    case "Materiaux":
      return (
        <>
          <h4>Type : {annonce.typeMateriel}</h4>
          <h4>État: {annonce.etat}</h4>
          <h4 className="descriptionBis">Description : {annonce.description}</h4>
        </>
      );
    case "artisanat":
      return (
        <>
          <h4>Type d'artisanat : {annonce.typeArt}</h4>
          <h4>Localisation : {annonce.ville}</h4>
          <h4 className="descriptionBis">Description : {annonce.description}</h4>
        </>
      );
    default:
      return null;
  }
}
